import React from "react";
import { Col,  Form,  Modal, Row, InputNumber } from "antd";
import { SUCCESS_COLOR } from "../../constants/color";
import { POST } from "../../frameworks/HttpClient";
import { URL_LAB, URL_POND, URL_TANK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import _ from "lodash";
import { LAB_ORDER_TYPE } from "../../constants/string";

export default function PondTankLabWeightModal(props) {
  const { open, onClose, target, onUpdate, role } = props;
  const [loading, setLoading] = React.useState(false)
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [form] = Form.useForm();
  const weightWatch = Form.useWatch('original_weight', form)

  const handleOK = async() => {
    setLoading(true)
    setErrorMessages(null)
    try {
      const data = await form.validateFields();
      await POST(URL_LAB.LAB_ORDER, {...data, ref : role === LAB_ORDER_TYPE.POND ? `${URL_POND.POND_TRANSACTION}${target.id}/` :  `${URL_TANK.TANK_TRANSACTION}${target.id}/`})
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if(open){
      form.setFieldsValue({
        original_weight : target.current_weight,
        original_height : target.current_height
      })
      setErrorMessages(null)
    }
  },[open])

  return(
    <Modal
      open={open}
      onCancel={onClose}
      title={`เพิ่มตัวอย่าง [${_.get(target, 'lot_no', '-')}]`}
      width={500}
      okText={"ยืนยัน"}
      cancelText={"ยกเลิก"}
      okButtonProps={{ style: { backgroundColor : SUCCESS_COLOR}, loading: loading }}
      onOk={handleOK}
    >
      <ErrorMessages message={errorMessages}/>
      <Form 
        form={form}
        layout={'vertical'}
      >
        <Row>
          <Col span={12}>
            <Form.Item 
              name={'original_weight'}
              label={'น้ำหนัก (Kg)'}
              rules={[{ required: true, message: 'กรุณากรอกน้ำหนัก!' }]}
            >
              <InputNumber placeholder="น้ำหนัก" style={{ width : '95%'}} precision={0}/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              name={'original_height'}
              label={'ความสูง (Cm)'}
              // rules={[{ required: true, message: 'กรุณากรอกความสูง!' }]}
            >
              <InputNumber 
                autoComplete="off" 
                style={{ width : '95%', marginLeft : 5 }} 
                placeholder="ส่วนสูง" 
                onChange={(value) => form.setFieldValue('original_weight', Math.round(value * target.weight_per_height))}
                onPressEnter={(e) => !weightWatch ? form.setFieldValue('original_weight', (e.target.value * target.weight_per_height)) : handleOK()} 
              />
          </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}